import React from 'react';
import LogoutContent from 'componentes/authentication/LogoutContent.js';

const Logout = () => (
  <div className="text-center">
    <LogoutContent />
  </div>
);

export default Logout;
